import './style.css'
export const ModalHeading = ({ heading }) => {
  return (
    <div className="note-header">
      <h5 className="mb-0">{heading}</h5>
    </div>
  );
};
